import * as Sentry from '@sentry/react';
import {useQuery} from '@tanstack/react-query';
import {AxiosError} from 'axios';
import toaster from 'react-hot-toast';
import {getPayrocMerchantAccounts} from 'api/admin/businesses/getPayrocMerchantAccounts';
import {IndividualPayrocMerchantAccount} from 'api/admin/businesses/getPayrocMerchantAccounts';

export const usePayrocMerchants = (businessId: number) => {
    const {
        isLoading,
        error,
        data = [],
        refetch,
    } = useQuery<unknown, AxiosError<{ error: string }>, IndividualPayrocMerchantAccount[]>({
        queryKey: ['getPayrocMerchantAccounts', businessId],
        queryFn: async () => {
            const response = await getPayrocMerchantAccounts(businessId);
            return response.data?.payrocMerchantAccounts ?? [];
        },
        retry: 1,
        onError: (error) => {
            Sentry.captureException(error);

            toaster(
                error?.response?.data?.error ?? 'An error occurred while fetching merchant accounts',
                {
                    icon: '❌',
                },
            );
            return error;
        },
    });

    return {
        isLoading,
        error,
        data,
        refetch,
    };
};
